module.exports = __webpack_public_path__ + "static/media/Send Now or Schedule for Later.23fbee6e.png";